const items = [
  "Echocardiogram",
  "12-Lead ECG",
  "Holter 24h – 28 Days",
  "Ambulatory BP · Beat-to-Beat",
  "Research Imaging",
  "Clinical Governance",
];

export const Marquee = () => (
  <div
    className="bg-navy border-y border-gold/30 py-5 overflow-hidden"
    data-testid="editorial-marquee"
  >
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {items.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-serif italic text-2xl text-ivory/90 px-8 whitespace-nowrap">
                {item}
              </span>
              <span className="text-gold text-sm">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
